import DTextField from "components/common/DTextField";

export default function TextFieldRenderer({
    field,
    form,
    setForm,
    errors,
    showValidation,
    disabled,
    ...rest
}) {
    const onChange = (event) =>
        setForm((prev) => ({
            ...prev,
            [field.name]: event.target.value
        }));

    return (
        <DTextField
            fullWidth
            margin="normal"
            label={field.label}
            value={form[field.name] ?? ""}
            required={field.required}
            error={showValidation && !!errors[field.name]}
            helperText={showValidation ? (errors[field.name] ?? "") : ""}
            onChange={onChange}
            disabled={disabled}
            // sx={{ marginBottom: "unset", marginTop: "unset", margin: "4px" }}
        />
    );
}
